import React from 'react'
import AddFilter from '../../../../Components/Filters/AddFilter'

export default function AddProjectFilter() {
  return (
    <AddFilter department="mall"/>
  )
}
